import * as React from "react";

function SvgSupportDuo({ title, titleId, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <path
          fill="#374151"
          d="M16.525 3.364l.29.16.124-.064a1.756 1.756 0 011.86.24l.12.11 1.272 1.273c.575.575.662 1.44.286 2.104a9.744 9.744 0 010 9.63c.35.617.297 1.411-.178 1.982l-.109.12-1.273 1.272a1.754 1.754 0 01-2.103.287 9.747 9.747 0 01-9.63-.001 1.755 1.755 0 01-1.983-.178l-.12-.109-1.272-1.273a1.754 1.754 0 01-.287-2.103 9.75 9.75 0 010-9.63A1.755 1.755 0 013.7 5.201l.109-.12L5.082 3.81a1.754 1.754 0 012.103-.287 9.75 9.75 0 019.34-.158zM9.892 17.37L8.26 19.353a8.252 8.252 0 007.48.001l-1.634-1.984a5.783 5.783 0 01-4.214 0zm-.91-8.387a4.267 4.267 0 106.191.164l-.156-.164-.164-.156a4.266 4.266 0 00-5.87.156zm10.372-.721L17.37 9.894a5.78 5.78 0 010 4.213l1.984 1.633a8.254 8.254 0 000-7.478zM4.646 8.26a8.254 8.254 0 000 7.478l1.984-1.632a5.783 5.783 0 010-4.214L4.646 8.26zM8.26 4.646L9.893 6.63a5.783 5.783 0 014.214 0l1.633-1.983a8.248 8.248 0 00-7.48 0z"
        />
        <path
          fill="#98DB69"
          d="M16.63 15.44l2.481 2.044.043.045a.255.255 0 01-.025.33l-1.272 1.272-.05.038a.251.251 0 01-.324-.057l-2.044-2.481a5.804 5.804 0 001.19-1.191zm-9.26 0a5.893 5.893 0 001.19 1.189l-2.044 2.482-.045.043a.255.255 0 01-.33-.025L4.87 17.857l-.038-.05a.251.251 0 01.057-.324zM17.529 4.845a.255.255 0 01.33.025l1.272 1.272.038.05a.251.251 0 01-.057.324L16.63 8.56a5.809 5.809 0 00-1.189-1.19l2.043-2.482zM6.191 4.83a.252.252 0 01.325.057L8.56 7.37a5.809 5.809 0 00-1.19 1.19L4.888 6.516l-.043-.045a.255.255 0 01.025-.33L6.142 4.87z"
        />
      </g>
    </svg>
  );
}

export default SvgSupportDuo;
